import './Community.scss'
import CommunityProps from './CommunityProps';
import { BiCommentDetail as CommentIcon } from "react-icons/bi";
import { FiUsers as UsersIcon } from "react-icons/fi";
import temp_community_photo from './../../../../assets/images/temp-community-photo.jpeg';
import { useNavigate } from 'react-router-dom';

const Community = (props: CommunityProps) => {
    const navigate = useNavigate();
    const { community } = props;

    const goToCommunityPage = (id: string) => {
        navigate('/community/' + id)
    }

    return (
        <div className="community animate__animated animate__pulse" onClick={() => goToCommunityPage(community._id)}>
            <img className="community-photo" src={community.image ? community.image : temp_community_photo} alt="community" />
            <div className="gradient"></div>
            <div className="community-text w-100">
                <div className="community-name px-4">{community.communityName}</div>
                <div className="d-flex flex-wrap pt-3 align-items-end">
                    <div className="community-description px-4 col-12 col-md-8">{community.description}</div>
                    <div className="community-tabs col-12 col-md-4">
                        <div className="tab">
                            <CommentIcon className="icon" />
                            <div className="number-bold">{community?.posts?.length ? community?.posts?.length : 0}</div>
                            <div className="">Items</div>
                        </div>
                        <div className="tab">
                            <UsersIcon className="icon" />
                            <div className="number-bold">{community?.users?.length ? community?.users?.length : 0}</div>
                            <div className="">Members</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Community;